

import AddTransactionToPosition from "@/components/transaction/AddTransactionToPosition";
import { transactionTypes } from "@/constants/transaction";
import { backendExceptionHandler } from "@/mixins";
import CsvImportService from "@/service/CsvImportService";
import { POSITION_ACTIONS } from "@/constants/positionAction";

    export default {
        name: 'AddPositionToPortfolio',
        mixins: [backendExceptionHandler],
        components: { AddTransactionToPosition },
        props: {
            share: Object,
            interval: String
        },

        data () {
            return {
                portfolios: [],
                dialogMode: null,
                queryPortfolioId: null,
            }
        },

        computed: {
            isLoggedIn() {
                return this.$store.state.account.user
            },
            sellIconPath() {
                return this.$vuetify.theme.dark ?
                    require('@/assets/icons/sell-dark.svg') :
                    require('@/assets/icons/sell-light.svg');
            },
        },

        methods: {
            handleOpenDialog() {
                const query = this.$route.query ?? {};                
                if (!query.dialogMode || !query.portfolioId) {
                    return;
                }

                if (query.dialogMode === POSITION_ACTIONS.buy || query.dialogMode === POSITION_ACTIONS.sell) {
                    this.$router
                        .replace({
                            path: this.$router.currentRoute.path,
                        })
                        .catch(() => {                                
                            // Catch to avoid navigate error
                        })

                    this.openWindow(query.dialogMode, query.portfolioId);
                }
            },
            openWindow(type = null, portfolioId = null) {
                if (!this.isLoggedIn) {
                    this.$router.push({ name: this.$getTranslatedRouteName('signup') })
                    return
                }
                const transactionData = JSON.parse(JSON.stringify(this.share))
                transactionData.logo = transactionData.companyLogo
                transactionData.instrumentType = transactionData.type
                transactionData.type = type
                transactionData.qty = 0
                transactionData.id = null
                transactionData.portfolioId = portfolioId

                this.$root.$emit('request-transaction-window', transactionData, 0)
            },

            queryPortfolios() {
                const url = this.$store.state.preferences.isSandboxMode ? '/api/portfolio_tabs?context=virtual' : '/api/portfolio_tabs';
                this
                    .$axios
                    .get(url)
                    .then(response => {
                        this.portfolios = response.data.filter(function(portfolio){
                          return portfolio.portfolioType != "linked" && !portfolio.live;
                        });
                        this.$nextTick(() => {
                            this.handleOpenDialog()
                        })
                    })
                    .catch(error => {
                        this.handleBackendException(error, this.$t('component.portfolio.addPositionToPortfolio.portfolioFetchFailed'))
                    })

            },

            onIntersect (entries) {
                entries[0].target.classList.toggle("is-sticky", entries[0].intersectionRatio < 1)
            },
        },

        created() {
            this.csvImportService = new CsvImportService(this.$axios, this.$store)
            this.transactionTypes = transactionTypes
        },

        watch: {
            isLoggedIn: {
                handler: function() {
                    if (this.isLoggedIn) {
                        this.queryPortfolios()
                    }
                },
                immediate: true,
            },
        }
    }
